import { render, staticRenderFns } from "./Attivita.vue?vue&type=template&id=3a8c0e0d&"
import script from "./Attivita.vue?vue&type=script&lang=js&"
export * from "./Attivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports